import React from 'react';
import { connect } from 'react-redux';
import { TitleComponent } from '_components'
import { withRouter, Route } from 'react-router-dom'
import { RouteDefs } from '_constants'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { userActions } from '_actions';
import { SettingsButton } from './SettingsButton';
import styles from './Title.module.css'

const HeaderTitle = props => (
    <div>
        <div className={styles.title}>
            <Route exact path={RouteDefs.therapistDashboard.path} render={() =>
                <div>
                    <TitleComponent title={RouteDefs.therapistDashboard.title} />
                    {RouteDefs.therapistDashboard.header}
                </div>
            } />
            <Route path={RouteDefs.messageCenter.path} render={() =>
                <div>
                    <TitleComponent title={RouteDefs.messageCenter.title} />
                    {RouteDefs.messageCenter.header}
                </div>
            } />

            <Route path={RouteDefs.patientCareCenter.path} render={() =>
                <div>
                    <TitleComponent title={RouteDefs.patientCareCenter.title} />
                    {RouteDefs.patientCareCenter.header}
                </div>
            } />

            <Route path={RouteDefs.reportCenter.path} render={() =>
                <div>
                    <TitleComponent title={RouteDefs.reportCenter.title} />
                    {RouteDefs.reportCenter.header}
                </div>
            } />

            <Route path={RouteDefs.helpCenter.path} render={() =>
                <div>
                    <TitleComponent title={RouteDefs.helpCenter.title} />
                    {RouteDefs.helpCenter.header}
                </div>
            } />

            <Route path={RouteDefs.search.path} render={() =>
                <div>
                    <TitleComponent title={RouteDefs.search.title} />
                    {RouteDefs.search.header}
                </div>
            } />

        </div>

        <div className={styles.therapistname}>
            <label>{<SettingsButton />}</label>
            <label>{props.fullName}</label>
            <label title="Sign Out" className={styles.logout} onClick={() => props.logout()}>
                <FontAwesomeIcon icon={faSignOutAlt} />
            </label>
        </div>
    </div>
);

function mapDispatchToProps(dispatch) {
    return {
        logout: bindActionCreators(userActions.logout, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        fullName: state.entities.authentication.user ? (state.entities.authentication.user.firstname || "") + " " + (state.entities.authentication.user.lastname || "") : ""
    }
}

const connectedHeaderTitle = withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderTitle));
export { connectedHeaderTitle as HeaderTitle };

